import { convertSnakeCaseToCamelCase } from '../../../../web-components/utils/formatterResponse'

export function responseInterceptor(response: any) {
  return convertSnakeCaseToCamelCase(response)
}
